import {
    CloseIcon,
    Divider,
    Dropdown,
    Flex,
    Loader,
    Text,
} from "@fluentui/react-northstar";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Search28Regular } from "@fluentui/react-icons";
import { useQuery } from "react-query";
import { _getAllOffBoardingUsers } from "../../api";
import { debounce } from "../../../../utils/global";
import { DEBOUNCE_DELAY } from "../../constant";
import { AVATAR_DEFAULT } from "../../../../constants";
import { ContainerFluid } from "../../../../common/styles";
export default function OffboardingSearchBar({
    AgencyId,
    SelectedUser,
    setSelectedUser,
}) {
    const {
        data: all_offboarding_users,
        isLoading: isLoadingAllOffboardingUser,
        isFetching: isFetchingAllOffboardingUser,
        refetch,
    } = useQuery(
        ["getAllUser", AgencyId],
        () => {
            return _getAllOffBoardingUsers(AgencyId);
        },
        {
            enabled: AgencyId !== null,
            refetchOnWindowFocus: false,
            onSuccess: () => {
                // return setRefresh(new Date().getTime());
            },
        }
    );

    useEffect(() => {
        setSelectedUser(null);
    }, [AgencyId]);

    const handleChange = debounce((e) => {
        if (e?.target?.value?.length <= 2) {
            return setSelectedUser(null);
        } else {
            console.log("user_typing : ", e.target.value);
            setSelectedUser(e.target.value);
        }
        return;
    }, DEBOUNCE_DELAY);

    const data =
        all_offboarding_users?.map((el) => {
            return {
                header: el?.name,
                image: el?.avatar || AVATAR_DEFAULT,
                id: el.id,
            };
        }) ?? [];

    return (
        <ContainerFluid fill>
            <Flex styles={{ paddingBlock: "14px" }} fill hAlign="center">
                <DropdownStyled
                    fluid
                    search
                    items={data ?? []}
                    value={SelectedUser}
                    placeholder="Rechercher un collaborateur"
                    loading={
                        isLoadingAllOffboardingUser ||
                        isFetchingAllOffboardingUser
                    }
                    noResultsMessage={
                        data ? (
                            "Aucun résultat trouvé."
                        ) : (
                            <Text content="Chargement..." />
                        )
                    }
                    itemToString={(e) => {
                        if (e) {
                            return e?.header;
                        } else {
                            return "";
                        }
                    }}
                    a11ySelectedItemsMessage="Press Delete or Backspace to remove"
                    inverted
                    // clearable
                    toggleIndicator={
                        <Flex>
                            <Divider
                                style={{
                                    width: "10px",
                                    height: "30px",
                                    marginRight: "16px",
                                }}
                                vertical
                            />
                            {SelectedUser !== null ? (
                                <CloseIcon
                                    size="large"
                                    style={{
                                        color: "#5B5FC7",
                                        marginTop: "5px",
                                    }}
                                    onClick={() => {
                                        // setSelectedUser(null);
                                        setSelectedUser(null);
                                    }}
                                />
                            ) : (
                                <Search28Regular style={{ color: "#5B5FC7" }} />
                            )}
                        </Flex>
                    }
                    onChangeCapture={(e) => handleChange(e)}
                    onChange={(e, data) => {
                        setSelectedUser(data?.value ?? null);
                        if (data?.value) {
                            setSelectedUser(data?.value);
                        } else {
                            setSelectedUser(null);
                        }
                    }}
                />
            </Flex>
        </ContainerFluid>
    );
}

const DropdownStyled = styled(Dropdown)`
    border-radius: 16px;
    border: 1px solid #d1d1d1;
    background: #fff;
    /* width: 100%; */
    align-items: center;
    display: flex;
    width: 900px;
    height: 50px;
    padding: 16px;
    /* border: none; */
    background: white;
    .ui-dropdown__container,
    .ui-dropdown__container:active,
    .ui-dropdown__container:hover {
        border-bottom-style: hidden; /* Ou border-bottom: none; */
        background-color: #fff;
    }
    /* .ui-dropdown__container .ui-dropdown__searchinput__input:focus {
        border-bottom-style: hidden;
    } */
`;
